import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeatIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 12C5.16667 12 4.38611 11.8417 3.65833 11.525C2.93056 11.2083 2.29722 10.7806 1.75833 10.2417C1.21944 9.70278 0.791667 9.06944 0.475 8.34167C0.158333 7.61389 0 6.83333 0 6C0 5.16667 0.158333 4.38611 0.475 3.65833C0.791667 2.93056 1.21944 2.29722 1.75833 1.75833C2.29722 1.21944 2.93056 0.791667 3.65833 0.475C4.38611 0.158333 5.16667 0 6 0C6.91111 0 7.775 0.194444 8.59167 0.583333C9.40833 0.972222 10.1 1.52222 10.6667 2.23333V0.666667H12V4.66667H8V3.33333H9.83333C9.37778 2.71111 8.81667 2.22222 8.15 1.86667C7.48333 1.51111 6.76667 1.33333 6 1.33333C4.7 1.33333 3.59722 1.78611 2.69167 2.69167C1.78611 3.59722 1.33333 4.7 1.33333 6C1.33333 7.3 1.78611 8.40278 2.69167 9.30833C3.59722 10.2139 4.7 10.6667 6 10.6667C7.16667 10.6667 8.18611 10.2889 9.05833 9.53333C9.93056 8.77778 10.4444 7.82222 10.6 6.66667H11.9667C11.8 8.18889 11.1472 9.45833 10.0083 10.475C8.86944 11.4917 7.53333 12 6 12ZM7.86667 8.8L5.33333 6.26667V2.66667H6.66667V5.73333L8.8 7.86667L7.86667 8.8Z",
		fill: "currentColor"
	})
});
export default SvgRepeatIcon;
